import { createAxiosClient } from "@ntg/component-library/utilities";
import { IComparisonInfo } from "../../declarations/types";
import { IReadVerbPayload } from "../../declarations/IReadVerbPayload";

export const getProductComparison = async (
    payload: IReadVerbPayload,
): Promise<IComparisonInfo[]> => {
    const axiosAuth = createAxiosClient("D365FO");
    const response = await axiosAuth.post<IComparisonInfo[]>(
        `/Product/ProductComparisonInfoD365`,
        payload,
    );
    return response.data;
};
